import { useEffect } from 'react';
import { useFormik } from 'formik';

import { PqrTimeDate } from '../../../../../../shared/types/paramPqrTimes';
import { useGetNameOrValue } from '../../../../../../shared/utils/useGetNameOrValue';

export const usePqrTimesData = (data?: PqrTimeDate) => {
    const formik = useFormik({
        initialValues: {
            typeSacTime: '',
            typeClassificationSacTime: '',
            sacTime: '',

            typeFuragTime: '',
            typeClassificationFuragTime: '',
            furagTime: '',
        },
        onSubmit: console.log,
    });

    useEffect(() => {
        formik?.setFieldValue('typeSacTime', data?.typeSacTime || '');
        formik?.setFieldValue(
            'typeClassificationSacTime',
            data?.typeClassificationSacTime || ''
        );
        formik?.setFieldValue('sacTime', data?.sacTime || '');

        formik?.setFieldValue('typeFuragTime', data?.typeFuragTime || '');
        formik?.setFieldValue(
            'typeClassificationFuragTime',
            data?.typeClassificationFuragTime || ''
        );
        formik?.setFieldValue('furagTime', data?.furagTime || '');
    }, [data]);

    useEffect(() => {
        formik.setValues({
            sacTime: useGetNameOrValue(data?.sacTime || ''),
            typeClassificationSacTime: useGetNameOrValue(
                data?.typeClassificationSacTime || ''
            ),
            typeSacTime: useGetNameOrValue(data?.typeSacTime || ''),
            typeFuragTime: useGetNameOrValue(data?.typeFuragTime || ''),
            typeClassificationFuragTime: useGetNameOrValue(
                data?.typeClassificationFuragTime || ''
            ),
            furagTime: useGetNameOrValue(data?.furagTime || ''),
        });
    }, [data]);

    return {
        formik,
    };
};
